import { render, staticRenderFns } from "./WithdrawalList.vue?vue&type=template&id=08af6a7e&"
import script from "./WithdrawalList.vue?vue&type=script&lang=js&"
export * from "./WithdrawalList.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports